import {
    ADD, DECREASE, REMOVE
} from "./actionTypes";
import initialState from "./initialState";

const reducer = (state = initialState, action) => {
    const { payload: prodcutId } = action;

    switch (action.type) {
        case ADD:
            const product = state.find(product => product.productId === prodcutId);
            return product
                ? state.map(product =>
                    product.productId !== prodcutId ? product : { ...product, quantity: product.quantity + 1 }
                )
                : [...state, {
                    productId: prodcutId,
                    quantity: 1
                }];

        case DECREASE:
            return state.map(product => product.productId !== prodcutId ? product : { ...product, quantity: product.quantity - 1 })

        case REMOVE:
            return state.filter(product => product.productId !== prodcutId)
            
        default:
            return state;
    }
};



export default reducer;
